import gql from "graphql-tag";

export const ALL_IMAGES = gql`
  query MyQuery($number: Int!) {
    posts(first: $number) {
      nodes {
        acf_shooting {
          thumbnailShooting {
            srcSet(size: WIDE)
            sourceUrl(size: WIDE)
            altText
            categories {
              nodes {
                slug
              }
            }
          }
        }
        slug
      }
    }
  }
`;

export const ALL_LINKS = gql`
  query MyQuery($number: Int!) {
    categories(where: { orderby: NAME, exclude: "1" }) {
      nodes {
        name
        slug
      }
    }
    posts(first: $number) {
      nodes {
        slug
        title(format: RENDERED)
      }
    }
  }
`;

export const ALL_CATEGORIES = gql`
  query MyQuery {
    categories(where: { orderby: NAME, exclude: "1" }) {
      nodes {
        acf_categories {
          imageCategory {
            altText
            srcSet(size: WIDE)
            sourceUrl(size: WIDE)
          }
        }
        name
        slug
        description
      }
    }
  }
`;

export const ALL_SHOOTINGS = gql`
  query MyQuery($number: Int!) {
    posts(first: $number) {
      nodes {
        slug
        title(format: RENDERED)
        date
        acf_shooting {
          thumbnailShooting {
            altText
            sourceUrl(size: WIDE)
            srcSet(size: WIDE)
          }
        }
      }
    }
  }
`;

export const CATEGORY = gql`
  query MyQuery($id: ID!) {
    category(idType: SLUG, id: $id) {
      name
      description
      mediaItems(first: 50) {
        nodes {
          sourceUrl(size: WIDE)
          srcSet(size: WIDE)
          altText
        }
      }
    }
  }
`;

export const SHOOTING = gql`
  query MyQuery($id: ID!) {
    post(idType: SLUG, id: $id) {
      date
      title(format: RENDERED)
      content(format: RENDERED)
      acf_shooting {
        galleryShooting {
          srcSet(size: WIDE)
          sourceUrl(size: WIDE)
          altText
          categories {
            nodes {
              name
            }
          }
        }
        modelsShooting {
          fullname
          pseudoInstagram
        }
      }
    }
  }
`;

export const FOOTER = gql`
  query MyQuery {
    siteGeneralSettings {
      instagram {
        userInstagramName
        userInstagramPseudo
      }
    }
  }
`;

export const CONTACT = gql`
  query MyQuery {
    siteGeneralSettings {
      instagram {
        userInstagramName
        userInstagramPseudo
      }
      informations {
        userAbout
        userEmail
      }
    }
  }
`;

export const LEGAL = gql`
  query MyQuery {
    siteGeneralSettings {
      legal {
        descriptionLegal
        titleLegal
        upTitleLegal
      }
    }
  }
`;
